import handleSubmitButtonClick from './handle-submit-button-click'

export default () => handleSubmitButtonClick()
